import { DiffStates } from '@interface/index';

export interface CompositeInherit {
  id: string;
  name: string;
  type: string;
  state?: DiffStates;
}
